(function () {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('valorisation', {
            parent: 'technicienMenu',
            url: '/valorisation?page&sort&technicien&date&type&annee&semaine',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.valorisation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/valorisation/valorisation.html',
                    controller: 'ValorisationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        technicien: $stateParams.technicien,
                        date: $stateParams.date,
                        type: $stateParams.type,
                        annee: $stateParams.annee,
                        semaine: $stateParams.semaine,
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('valorisation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('valorisation-detail', {
            parent: 'valorisation',
            url: '/valorisation/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.valorisation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/valorisation/valorisation-detail.html',
                    controller: 'ValorisationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('valorisation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Valorisation', function ($stateParams, Valorisation) {
                    return Valorisation.get({id: $stateParams.id}).$promise;
                }],
                previousState: ['$state', function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'valorisation',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('valorisation.new', {
            parent: 'valorisation',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/valorisation/valorisation-dialog.html',
                    controller: 'ValorisationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null,
                                technicien: null,
                                date: null,
                                commentary: null,
                                point: null,
                                type: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('valorisation', null, { reload: 'valorisation' });
                }, function() {
                    $state.go('valorisation');
                });
            }]
        })
        .state('valorisation.edit', {
            parent: 'valorisation',
            url: '{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/valorisation/valorisation-dialog.html',
                    controller: 'ValorisationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Valorisation', function(Valorisation) {
                            return Valorisation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('valorisation', null, { reload: 'valorisation' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('valorisation.delete', {
            parent: 'valorisation',
            url: '{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/valorisation/valorisation-delete-dialog.html',
                    controller: 'ValorisationDeleteController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['Valorisation', function(Valorisation) {
                            return Valorisation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('valorisation', null, { reload: 'valorisation' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }
})();
